import type { FamilyHistoryFact } from '@liza/fhir-utils';
import { useTranslation } from 'react-i18next';
import { type FamilyHistoryItemProps, factOnset } from './familyHistoryRows';
import { RecordListItem } from './RecordListItem';

export type FamilyHistoryFactItemProps = FamilyHistoryItemProps & { fact: FamilyHistoryFact; title: string };

/** One fact under a condition or the unattributed row; selecting it opens the resource it came from. */
export const FamilyHistoryFactItem = ({
  fact,
  title,
  onSelectFamilyMember,
  selectedFamilyMemberId,
  onPromotionClick,
  getPromotionStatus,
}: FamilyHistoryFactItemProps): React.ReactElement => {
  const { t } = useTranslation('records');
  const recordId = fact.sources[0]!.record.id;
  const onset = factOnset(fact, t);
  return (
    <RecordListItem
      testId="family-history-fact"
      title={title}
      description={onset ? `${t('onset')}: ${onset}` : undefined}
      onClick={onSelectFamilyMember ? (): void => onSelectFamilyMember(recordId) : undefined}
      selected={fact.sources.some((s) => s.record.id === selectedFamilyMemberId)}
      onPromotionClick={onPromotionClick ? (): void => onPromotionClick(recordId) : undefined}
      promotionStatus={getPromotionStatus?.(recordId)}
    />
  );
};
